/**
 * Created by pyt on 1/18/17.
 */
export const SAVE_AUDIENCERULE_CUSTOM_GROUP = 'SAVE_AUDIENCERULE_DEVICE_ID_GROUP';
export const UPDATE_AUDIENCERULE_CUSTOM_GROUP = 'UPDATE_AUDIENCERULE_DEVICE_ID_GROUP';
export const UPDATE_AUDIENCERULE_CUSTOM_GROUPS_LIST = 'UPDATE_AUDIENCERULE_DEVICE_ID_GROUPS_LIST';
